import React from 'react';
import styles from './Contact.module.css';

const Contact = () => {
  const openOrderForm = () => {
    window.open('https://form.jotform.com/212676109824358', '_blank', 'width=650,height=743');
  };

  const menuItems = [
    { label: 'О компании', href: '#about' },
    { label: 'Как заказать чеки ?', href: '#order' },
    { label: 'Что входит в услугу ?', href: '#documents' },
    { label: 'Примеры чеков', href: '#examples' },
    { label: 'Наши особенности', href: '#advantages' },
    { label: 'Отзывы клиентов', href: '#reviews' }
  ];

  const scrollToSection = (href) => {
    const sectionId = href.replace('#', '');
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="contact" className={styles.contact}>
      <div className={styles.contactDivider}></div>
      <div className="container">
        <div className={styles.contactContent}>
          <div className={styles.contactCard}>
            <div className={styles.contactHeader}>
              <div className={styles.divider}></div>
              <h3 className={styles.contactTitle}>Контакты</h3>
            </div>
            
            <div className={styles.contactInfo}>
              <div className={styles.contactItem}>
                <strong>+7 (987) 481-79-32</strong>
              </div>
              <div className={styles.contactItem}>
                mirat7932@mail.ru
              </div>
              <div className={styles.contactItem}>
                <strong>Работаем территориально:</strong>
              </div>
              <div className={styles.contactItem}>
                по Челябинску и области
              </div>
            </div>
            
            <div className={styles.socialLinks}>
              <button className={styles.socialLink} aria-label="Dribbble">
                <i className="fa fa-dribbble"></i>
              </button>
              <button className={styles.socialLink} aria-label="Facebook">
                <i className="fa fa-facebook"></i>
              </button>
              <a href="mailto:mirat7932@mail.ru" className={styles.socialLink} aria-label="Email">
                <i className="fa fa-envelope"></i>
              </a>
              <button className={styles.socialLink} aria-label="LinkedIn">
                <i className="fa fa-linkedin"></i>
              </button>
            </div>
          </div>

          <div className={styles.menuCard}>
            <h4 className={styles.menuTitle}>Основное по сайту:</h4>
            <nav className={styles.menuNav}>
              {menuItems.map((item, index) => (
                <a 
                  key={index}
                  href={item.href}
                  className={styles.menuLink}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection(item.href);
                  }}
                >
                  <i className="fa fa-angle-right"></i>
                  {item.label}
                </a>
              ))}
            </nav>
          </div>

          <div className={styles.orderInfo}>
            <div className={styles.orderText}>
              <p>
                Что бы быстро заказать и купить гостиничные чеки в Челябинске - заполните онлайн заявку ниже, 
                и с вами оперативно свяжется наш оператор по оставленным контактам:
              </p>
            </div>
            <button 
              className={`btn btn-secondary ${styles.orderButton}`}
              onClick={openOrderForm}
            >
              Заказать чеки on-line
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;